import useSWR from "swr"
import {API_ECP_PROJECTS} from "../constants/apiUrls"

export default function useEcpAbstract(projectId) {
    const {data, mutate, error} = useSWR(`${API_ECP_PROJECTS}/${projectId}/abstract`, {revalidateOnFocus: false})
    return {
        ecpAbstract: data && data.abstract,
        mutateEcpAbstract: mutate,
        isLoadingEcpAbstract: !error && !data,
        isErrorEcpAbstract: error
    }
}